import { render } from "./notification-list.vue?vue&type=template&id=62bf42c2&scoped=true"
import script from "./notification-list.vue?vue&type=script&lang=js"
export * from "./notification-list.vue?vue&type=script&lang=js"

import "./notification-list.vue?vue&type=style&index=0&id=62bf42c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bf42c2"]])

export default __exports__